import React from 'react';
import Hero from '../components/sections/Hero';


const HomePage = () => {
  return (
    <div className="min-h-screen">
      <Hero />
      {/* <Portfolio /> */}
      {/* <MediaPlayer/> */}
      {/* <ContactSection /> */}
    </div>
  );
};

export default HomePage;